import { Options, Splide } from '@splidejs/splide'

import { isDesktopDown, mediaQueries } from '../../../../Resources/Private/TypeScript/Utility/Breakpoint'
import { getElements } from '../../../../Resources/Private/TypeScript/Utility/Dom'

class HighlightsSlider {
  private sliders: NodeListOf<HTMLElement>

  constructor() {
    this.sliders = getElements('highlights-slider')
  }

  public init(): void {
    this.sliders.forEach((slider): void => {
      const slides = slider.querySelectorAll('.splide__slide')
      const count = slides.length

      if (count < 2) {
        return
      }

      const breakpointQuery = mediaQueries.desktop.down

      const spaceGrid = getComputedStyle(slider).getPropertyValue('--space-grid').trim() || 'clamp(1rem, 6vw, 3rem)'

      const sliderOptions: Options = {
        arrows: false,
        breakpoints: {
          575: {
            padding: { left: spaceGrid, right: 'clamp(2.5rem, 12vw, 5rem)' },
            perPage: 1,
          },
          767: {
            padding: { left: spaceGrid, right: spaceGrid },
            perPage: 1,
          },
        },
        gap: '1.25rem',
        omitEnd: true,
        padding: 0,
        perPage: 2,
        trimSpace: true,
        type: 'slide',
      }

      const splide = new Splide(slider, sliderOptions)
      let isMounted = false

      splide.on('moved', (newIndex: number): void => {
        slides.forEach((slide, index): void => {
          slide.classList.toggle('is-slide-focus', index === newIndex)
        })
      })

      const toggleSlider = (isActive: boolean): void => {
        if (isActive) {
          if (!isMounted) {
            splide.mount()
            isMounted = true
          }
        } else {
          if (isMounted) {
            splide.destroy(true)
            isMounted = false
            slides.forEach((slide): void => {
              slide.classList.remove('is-slide-focus')
            })
          }
        }
      }

      const isInitiallyActive = isDesktopDown()
      toggleSlider(isInitiallyActive)

      breakpointQuery.addEventListener('change', (event): void => {
        toggleSlider(event.matches)
      })
    })
  }
}

const highlightsSlider = new HighlightsSlider()
highlightsSlider.init()
